/**
 * @generated SignedSource<<e4391871a99876ba591998dd8676acd7>>
 * @relayHash 69f493af18d64a7f4cf70f0087acbb00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55b906b1ae05d709d7caf4b653d8e101a4e11b8141feeb12d643b51e5daab820

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSyncSmartFolderInput = {
  folderId: string;
  force?: boolean | null;
};
export type useSyncSmartFolderMutation$variables = {
  cloudId: string;
  input: ConfluenceSyncSmartFolderInput;
};
export type useSyncSmartFolderMutation$data = {
  readonly confluence_syncSmartFolder: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useSyncSmartFolderMutation = {
  response: useSyncSmartFolderMutation$data;
  variables: useSyncSmartFolderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceSyncSmartFolderPayload",
    "kind": "LinkedField",
    "name": "confluence_syncSmartFolder",
    "plural": false,
    "selections": [
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSyncSmartFolderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSyncSmartFolderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "69f493af18d64a7f4cf70f0087acbb00",
    "id": "55b906b1ae05d709d7caf4b653d8e101a4e11b8141feeb12d643b51e5daab820",
    "metadata": {},
    "name": "useSyncSmartFolderMutation",
    "operationKind": "mutation",
    "text": "mutation useSyncSmartFolderMutation($cloudId:ID!,$input:ConfluenceSyncSmartFolderInput!){confluence_syncSmartFolder(cloudId:$cloudId,input:$input){errors{message},success}}"
  }
};
})();

(node as any).hash = "db0693038c4ec4b6cc2029ff542315a6";

export default node;
